var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramoverviewlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECFDF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_17099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1707 23.0099C29.8307 23.0136 31.1637 21.6766 31.1674 20.0166C31.1711 18.3566 29.844 17.0136 28.184 17.0099C26.524 17.0062 25.1811 18.3433 25.1774 20.0033C25.1737 21.6633 26.5107 23.0062 28.1707 23.0099ZM20.1707 22.9921C21.8307 22.9958 23.1637 21.6588 23.1674 19.9988C23.1711 18.3388 21.8441 16.9958 20.1841 16.9921C18.5241 16.9884 17.1811 18.3255 17.1774 19.9855C17.1737 21.6455 18.5107 22.9884 20.1707 22.9921ZM20.1663 24.9921C17.8363 24.9869 13.1637 26.1465 13.1585 28.4765L13.1529 30.9765L27.1529 31.0077L27.1585 28.5077C27.1636 26.1777 22.4963 24.9973 20.1663 24.9921ZM28.1662 25.0099C27.8762 25.0093 27.5462 25.0285 27.1961 25.0578C28.3543 25.9003 29.1617 27.0321 29.1585 28.5121L29.1529 31.0121L35.1529 31.0255L35.1584 28.5255C35.1636 26.1955 30.4962 25.0151 28.1662 25.0099Z",
    fill: "#00B944"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_17099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.0269 11.9731) rotate(0.127499)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramoverviewlogo);
export default __webpack_public_path__ + "static/media/programoverviewlogo.f730f4bb2c7575f9390e1fd78dd6fee3.svg";
export { ForwardRef as ReactComponent };